import { render, staticRenderFns } from "./FoliosRetrieve.vue?vue&type=template&id=53ef2634"
import script from "./FoliosRetrieve.vue?vue&type=script&lang=js"
export * from "./FoliosRetrieve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports